export enum ExportType {
  APPLICATION = 'APPLICATION',
  UPO = 'UPO',
  ATTACHMENT = 'ATTACHMENT',
}
